import { linkageApiKeyListPath } from '@/common/app/path'
import { LinkageApiKey } from '@/common/model/linkageApiKey'

import BackButton from '@/components/view/atoms/button/BackButton'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'

import LinkageApiKeyForm from '@/components/container/form/modules/admin/linkageApiKey/LinkageApiKeyForm'

interface Props {
  linkageApiKey?: LinkageApiKey
  onRefetch?: () => void
}

const LinkageApiKeyEditPage = ({ linkageApiKey, onRefetch }: Props) => {
  return (
    <Main type={MainLayoutType.SMALL}>
      <BackButton link={linkageApiKeyListPath()} />
      <LinkageApiKeyForm linkageApiKey={linkageApiKey} onRefetch={onRefetch} />
    </Main>
  )
}

export default LinkageApiKeyEditPage
